// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"27285c26","190":"27285c26","325":"27285c26","699":"27285c26","715":"27285c26"}[chunkId] + ".chunk.css";
};